import {
  MailIcon,
  MessageSquareIcon,
  PhoneIcon,
  BellIcon,
  GlobeIcon,
  Share2Icon,
  MonitorIcon,
  type LucideIcon,
} from 'lucide-react'
import type { ChannelKey } from '../types/notice'

export const CHANNEL_ICONS: Record<ChannelKey, LucideIcon> = {
  email: MailIcon,
  sms: MessageSquareIcon,
  voice: PhoneIcon,
  push: BellIcon,
  website: GlobeIcon,
  social: Share2Icon,
  screens: MonitorIcon,
}

export const CHANNEL_LABELS: Record<ChannelKey, { fr: string; en: string }> = {
  email: { fr: 'Courriel', en: 'Email' },
  sms: { fr: 'SMS', en: 'SMS' },
  voice: { fr: 'Appel vocal', en: 'Voice call' },
  push: { fr: 'Notification', en: 'Push notification' },
  website: { fr: 'Site web', en: 'Website' },
  social: { fr: 'Réseaux sociaux', en: 'Social media' },
  screens: { fr: 'Écrans publics', en: 'Public screens' },
}
